import { Controller } from "@hotwired/stimulus"

// Wstawia treść szablonu czatu do pola operatora (#chat-input, contenteditable).
// Próbuje wstawić tekst w ostatniej znanej pozycji kursora; jeśli nie ma takiej
// pozycji albo była poza polem — dokleja na końcu inputu.
export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.savedRange = null
    this.onSelectionChange = this.handleSelectionChange.bind(this)
    document.addEventListener("selectionchange", this.onSelectionChange)
  }

  disconnect() {
    document.removeEventListener("selectionchange", this.onSelectionChange)
  }

  handleSelectionChange() {
    const selection = window.getSelection()
    if (!selection || selection.rangeCount === 0) { return }
    const range = selection.getRangeAt(0)
    if (this.inputTarget.contains(range.startContainer) && this.inputTarget.contains(range.endContainer)) {
      this.savedRange = range.cloneRange()
    }
  }

  async insert(event) {
    event.preventDefault()
    const id = event.currentTarget.dataset.chatTemplateId
    if (!id) { return }

    const input = this.inputTarget
    input.focus()

    let text
    try {
      const response = await fetch(`/webchat/templates/${id}.json`, { headers: { Accept: "application/json" } })
      if (!response.ok) { return }
      const data = await response.json()
      text = data.template
    } catch (error) {
      console.error("chat template fetch failed", error)
      return
    }
    if (!text) { return }

    const range = this.savedRange
    const useSavedRange = range && input.contains(range.startContainer) && input.contains(range.endContainer)

    if (useSavedRange) {
      // wstawiamy tekst w miejscu kursora — usuwamy ewentualne zaznaczenie i wkładamy node
      range.deleteContents()
      const node = document.createTextNode(text)
      range.insertNode(node)
      range.setStartAfter(node)
      range.setEndAfter(node)
      const selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
    } else {
      // brak znanej pozycji kursora — bezpiecznie doklejamy na końcu i ustawiamy kursor za tekstem
      const node = document.createTextNode(text)
      input.appendChild(node)
      const newRange = document.createRange()
      newRange.setStartAfter(node)
      newRange.setEndAfter(node)
      const selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(newRange)
      this.savedRange = newRange.cloneRange()
    }
  }
}
